import "../assets/index-6416f636.css";
import { N as r } from "../chunks/index-cea13a24.mjs";
import o from "./NcDashboardWidgetItem.mjs";
import a from "./NcEmptyContent.mjs";
import { C as i } from "../chunks/Check-2ea0a88a.mjs";
import { t as m } from "../chunks/l10n-ef44019c.mjs";
import { n as l } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const c = {
  name: "NcDashboardWidget",
  components: {
    NcAvatar: r,
    NcDashboardWidgetItem: o,
    NcEmptyContent: a,
    Check: i
  },
  props: {
    /**
     * An array containing the items to show (specific structure must be respected,
     * except if you override item rendering in the default slot).
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * If this is set, a "show more" text is displayed on the widget's bottom.
     * It's a link pointing to this URL.
     */
    showMoreUrl: {
      type: String,
      default: ""
    },
    /**
     * The text of show more button.
     *
     * Expected to be in the form "More {itemName} …"
     */
    showMoreLabel: {
      type: String,
      default: m("More items …")
    },
    /**
     * A boolean to put the widget in a loading state.
     */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * An object containing context menu entries that will be displayed for each item.
     */
    itemMenu: {
      type: Object,
      default: () => ({})
    },
    /**
     * Whether both the items and the empty content message are shown.
     * Usefull for e.g. showing "No mentions" and a list of elements.
     */
    showItemsAndEmptyContent: {
      type: Boolean,
      default: !1
    },
    /**
     * The text to show in the empty content area.
     */
    emptyContentMessage: {
      type: String,
      default: ""
    },
    /**
     * The text to show in the half empty content area.
     */
    halfEmptyContentMessage: {
      type: String,
      default: ""
    }
  },
  computed: {
    // forward menu events to my parent
    handlers() {
      const n = {};
      for (const t in this.itemMenu)
        n[t] = (e) => {
          this.$emit(t, e);
        };
      return n;
    },
    displayedItems() {
      const n = this.showMoreUrl && this.items.length >= this.maxItemNumber ? this.maxItemNumber - 1 : this.maxItemNumber;
      return this.items.slice(0, n);
    },
    showHalfEmptyContentArea() {
      return this.showItemsAndEmptyContent && this.halfEmptyContentString && this.items.length !== 0;
    },
    halfEmptyContentString() {
      return this.halfEmptyContentMessage || this.emptyContentMessage;
    },
    maxItemNumber() {
      return this.showItemsAndEmptyContent ? 5 : 7;
    },
    showMore() {
      return this.showMoreUrl && this.items.length >= this.maxItemNumber;
    }
  }
};
var u = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "dashboard-widget" }, [t.showHalfEmptyContentArea ? e("NcEmptyContent", { staticClass: "half-screen", attrs: { description: t.halfEmptyContentString }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [t._t("halfEmptyContentIcon", function() {
      return [e("Check")];
    })];
  }, proxy: !0 }], null, !0) }) : t._e(), e("ul", t._l(t.displayedItems, function(s) {
    return e("li", { key: s.id }, [t._t("default", function() {
      return [e("NcDashboardWidgetItem", t._g(t._b({ attrs: { "item-menu": t.itemMenu } }, "NcDashboardWidgetItem", s, !1), t.handlers))];
    }, { item: s })], 2);
  }), 0), t.loading ? e("div", t._l(7, function(s) {
    return e("div", { key: s, staticClass: "item-list__entry" }, [e("NcAvatar", { staticClass: "item-avatar", attrs: { size: 44 } }), t._m(0, !0)], 1);
  }), 0) : t.items.length === 0 ? t._t("empty-content", function() {
    return [t.emptyContentMessage ? e("NcEmptyContent", { attrs: { description: t.emptyContentMessage }, scopedSlots: t._u([{ key: "icon", fn: function() {
      return [t._t("emptyContentIcon")];
    }, proxy: !0 }], null, !0) }) : t._e()];
  }) : t.showMore ? e("a", { staticClass: "more", attrs: { href: t.showMoreUrl, target: "_blank", tabindex: "0" } }, [t._v(" " + t._s(t.showMoreLabel) + " ")]) : t._e()], 2);
}, h = [function() {
  var n = this, t = n._self._c;
  return t("div", { staticClass: "item__details" }, [t("h3", [n._v(" ")]), t("p", { staticClass: "message" }, [n._v("   ")])]);
}], p = /* @__PURE__ */ l(
  c,
  u,
  h,
  !1,
  null,
  "1efcbeee",
  null,
  null
);
const v = p.exports;
export {
  v as default
};
